module.exports = __webpack_public_path__ + "img/theme-d.c5d963b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/theme-d.png
// module id = LskJ
// module chunks = 1